import {
	addPaymentStaleComment,
	getConsultantStalePayments,
} from '@/API/repositories/order';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useEffect, useState } from 'react';

const useConsultantFollowUpPayments = () => {
	const { addMessage } = useMessageQueueContext();
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();

	const [displayedRows, setDisplayedRows] = useState();
	const [modalOrderId, setModalOrderId] = useState(null);

	const isLoading = hasUnfilledRequest(getConsultantStalePayments);

	const fetchStalePayments = async () => {
		const response = await makeRequest(getConsultantStalePayments.bind(null));
		if (!response.data) {
			return addMessage('Something went wrong', 'error');
		}

		setDisplayedRows(response.data);
	};

	const openModal = (orderId) => {
		setModalOrderId(orderId);
	};

	const closeModal = () => {
		setModalOrderId(null);
	};

	const submitModal = async (e) => {
		e.preventDefault();
		const call = {
			result: e.target.result.value,
			comment: e.target.comment.value,
		};

		if (!call.result) {
			return addMessage('Result should not be empty');
		}
		if (call.result === 'picked_up' && !call.comment) {
			return addMessage('Add comment if picked up');
		}

		const response = await makeRequest(
			addPaymentStaleComment.bind(null, modalOrderId, call),
		);
		if (!response.data) {
			addMessage('Something went wrong', 'error');
		}

		closeModal();
		fetchStalePayments();
	};

	useEffect(() => {
		fetchStalePayments();
	}, []);

	return {
		displayedRows,
		isLoading,
		modalOrderId,
		openModal,
		closeModal,
		submitModal,
	};
};

export default useConsultantFollowUpPayments;
